import React from 'react';
import TopUpPackageSettings from '../../components/TopUpPackageSettings';

const TopUpPackageSettingsPage = () => {
    return <TopUpPackageSettings />;
};

export default TopUpPackageSettingsPage;
